interface NormalizedPhoto {
  caption?: string | null;
  findings?: Array<{ description?: string | null; measures?: string[] | null }> | null;
}

interface HazardItem {
  hazard?: string | null;
  measure?: string | null;
  selectedMeasures?: string[] | null;
}

interface CriticalHazard {
  hazard?: string | null;
  measure?: string | null;
  selectedMeasures?: string[] | null;
}

interface TbmFields {
  title?: string | null;
  content?: {
    workType?: string | null;
    specialNotes?: string | null;
    workDescription?: string | null;
    hazards?: string[] | null;
    safetyMeasures?: string[] | null;
    hazardItems?: HazardItem[] | null;
    criticalHazard?: CriticalHazard | null;
  } | null;
}

/**
 * TBM 페이지에서 동적 번역 대상 텍스트 수집.
 * 사용처: sign/[token].tsx, educator/[token].tsx, [id].tsx
 */
export function collectTbmDynamicTexts(
  tbm: TbmFields | null | undefined,
  normalizedPhotos: NormalizedPhoto[],
): string[] {
  const out: string[] = [];
  if (!tbm) return out;
  if (tbm.title) out.push(tbm.title);
  const c = tbm.content;
  if (c?.workType) out.push(c.workType);
  if (c?.specialNotes) out.push(c.specialNotes);
  if (c?.workDescription) out.push(c.workDescription);
  for (const photo of normalizedPhotos) {
    if (photo.caption) out.push(photo.caption);
    for (const finding of (photo.findings ?? [])) {
      if (finding.description) out.push(finding.description);
      for (const m of (finding.measures ?? [])) {
        if (m) out.push(m);
      }
    }
  }
  for (const item of (c?.hazardItems ?? [])) {
    if (item.hazard) out.push(item.hazard);
    const measures =
      item.selectedMeasures && item.selectedMeasures.length > 0
        ? item.selectedMeasures
        : item.measure
          ? [item.measure]
          : [];
    for (const m of measures) {
      if (m) out.push(m);
    }
  }
  if (Array.isArray(c?.hazards)) out.push(...(c!.hazards!.filter(Boolean) as string[]));
  if (Array.isArray(c?.safetyMeasures)) out.push(...(c!.safetyMeasures!.filter(Boolean) as string[]));
  const ch = c?.criticalHazard;
  if (ch?.hazard) out.push(ch.hazard);
  const chMeasures =
    ch?.selectedMeasures && ch.selectedMeasures.length > 0
      ? ch.selectedMeasures
      : ch?.measure
        ? [ch.measure]
        : [];
  for (const m of chMeasures) {
    if (m) out.push(m);
  }
  return out;
}
